/**
 * Meta Pixel Event Tracking Utility
 * Safely tracks custom events for Facebook/Instagram retargeting
 */

export const trackPixelEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// Pre-defined event helpers for Canvaart
export const pixelEvents = {
  // When user clicks "Contact to Buy" on any painting
  contactToBuy: (paintingTitle, paintingId, price, category) => {
    trackPixelEvent('ContactToBuy', {
      content_name: paintingTitle,
      content_ids: [String(paintingId)],
      content_type: 'painting',
      value: parseFloat(price) || 0,
      currency: 'INR',
      category: category || 'Artwork'
    });
  },

  // When user submits custom request form
  customRequestSubmit: (name, budget) => {
    trackPixelEvent('CustomRequest', {
      customer_name: name,
      estimated_budget: budget || 'Not specified'
    });
  },

  // When user places a bid on auction
  placeBid: (auctionTitle, auctionId, bidAmount) => {
    trackPixelEvent('PlaceBid', {
      content_name: auctionTitle,
      content_ids: [String(auctionId)],
      content_type: 'auction',
      value: parseFloat(bidAmount) || 0,
      currency: 'INR'
    });
  },

  // When user views a painting for potential retargeting
  viewPainting: (paintingTitle, paintingId, price, category) => {
    trackPixelEvent('ViewContent', {
      content_name: paintingTitle,
      content_ids: [String(paintingId)],
      content_type: 'painting',
      value: parseFloat(price) || 0,
      currency: 'INR',
      category: category || 'Artwork'
    });
  },

  // When user reads a blog post
  viewBlogPost: (postTitle, postSlug, category) => {
    trackPixelEvent('ViewBlogPost', {
      content_name: postTitle,
      content_ids: [postSlug],
      content_type: 'blog_post',
      category: category || 'Art Blog'
    });
  }
};

export default pixelEvents;
